import Mooring from './Mooring';
export default class MooringDepartureLineHandling extends Mooring {
    type;
    constructor(port, type, freeText) {
        super(port, freeText);
        this.type = type;
    }
}
//# sourceMappingURL=MooringDepartureLineHandling.js.map